import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { H2 } from 'foundations-components/transitional/components/H2';
import { NavMarker } from 'react-rhumb';
import { useLatestSavedItemsInteractions, usePlaylist } from '../../savedItems/savedItemsQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import I18n from 'I18n';
import { HasScope, useAccounts } from '../../accounts';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Field, Form, useForm } from 'react-final-form';
import { FinalFormField } from '../../../components/FinalForm';
import { Form as FoundationsForm } from 'foundations-components/transitional/components/Form';
import { useCallback } from 'react';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { required } from '../../../utils/validation';
import { useCreatePlaylistAssignment, usePlaylistAssignments, useUpdatePlaylistAssignments } from '../playlistAssignmentsQueries';
import { usePlaylistAssignmentsParams } from '../playlistAssignmentsHooks';
import useNavigate from '../../../hooks/useNavigate';
import { Alert } from 'foundations-components/transitional/components/Alert';
import ErrorBoundary from '../../../components/Errors/ErrorBoundary';
import { fromDateToUiDateInputFormat, fromUiDateInputFormatToUnixTs } from '../../../utils/CanvasComponents';
import { getAssignmentsForPortalUrl, getPortalAssignmentsUrl } from '../playlistAssignmentsRouting';
import { Redirect } from 'react-router-dom';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { View } from 'foundations-components/transitional/components/View';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
const tomorrowDate = new Date();
tomorrowDate.setDate(new Date().getDate() + 1);
const AccountsTabs = ({
  myAccounts,
  allAccounts
}) => {
  const form = useForm();
  const formState = form.getState();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Field, {
      name: "accountsRadio",
      render: ({
        input
      }) => /*#__PURE__*/_jsxs(ToggleGroup, {
        name: "accountsRadio",
        paddingBlockStart: "300",
        children: [/*#__PURE__*/_jsx(RadioInput, Object.assign({}, input, {
          defaultChecked: true,
          inline: true,
          value: "myAccounts",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.myAccounts"
          })
        })), /*#__PURE__*/_jsxs(RadioInput, Object.assign({}, input, {
          inline: true,
          value: "allAccounts",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.allAccounts"
          }), /*#__PURE__*/_jsx(Tooltip, {
            placement: "bottom",
            title: I18n.text('learningCenter.playlists.allAccountsTooltip'),
            children: /*#__PURE__*/_jsx(View, {
              display: "inline-block",
              marginInlineStart: "100",
              children: /*#__PURE__*/_jsx(InfoIcon, {
                size: "100"
              })
            })
          })]
        }))]
      })
    }), formState.values.accountsRadio === 'allAccounts' ? allAccounts : formState.values.accountsRadio === 'myAccounts' ? myAccounts : null]
  });
};
import { HubSpotterAccountUsersSelect } from './HubSpotterAccountUsersSelect';
import UsageTracker from '../../../utils/UsageTracker';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { Text } from 'foundations-components/components/Text';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { DateInput } from 'foundations-components/transitional/components/DateInput';
import { Select } from 'foundations-components/transitional/components/Select';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ServerError = ({
  error
}) => {
  if (!error) return null;
  return /*#__PURE__*/_jsxs(Alert, {
    marginBlockEnd: "300",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyErrors.badRequest.somethingsGoneWrong"
    }),
    type: "danger",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyErrors.badRequest.refreshPage"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyErrors.badRequest.keepsHappening"
    })]
  });
};
const HubSpotterPortalUserAssign = ({
  isMultiUserAccount,
  isEditing,
  accountId,
  accounts
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FinalFormField, {
      fieldProps: {
        name: 'account'
      },
      formControlProps: {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.assignPortal"
        }),
        marginBlockStart: '700'
      },
      hidden: !isMultiUserAccount,
      render: input => /*#__PURE__*/_jsx(TextInput, Object.assign({}, input, {
        disabled: accounts.length === 1 || isEditing,
        inputMode: "numeric",
        type: "text"
      })),
      validators: [required]
    }), /*#__PURE__*/_jsx(FinalFormField, {
      fieldProps: {
        name: 'assignees'
      },
      formControlProps: {
        marginBlockStart: '700',
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.assignAssignee"
        })
      },
      render: input => /*#__PURE__*/_jsx(HubSpotterAccountUsersSelect, Object.assign({}, input, {
        accountId: accountId,
        disabled: isEditing
      })),
      validators: [required]
    })]
  });
};
const StandardPortalUserAssign = ({
  isMultiUserAccount,
  isEditing,
  accountId,
  accounts
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FinalFormField, {
      fieldProps: {
        name: 'account'
      },
      formControlProps: {
        marginBlockStart: '700',
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.assignPortal"
        })
      },
      hidden: !isMultiUserAccount,
      render: input => /*#__PURE__*/_jsx(Select, Object.assign({}, input, {
        disabled: accounts.length === 1 || isEditing,
        options: accounts.map(account => ({
          value: account.id,
          text: I18n.text('learningCenter.playlists.assignAccountNameAndId', {
            accountName: I18n.SafeString(account.accountName),
            accountId: account.id.toString()
          })
        }))
      })),
      validators: [required]
    }), /*#__PURE__*/_jsx(FinalFormField, {
      fieldProps: {
        name: 'assignees'
      },
      formControlProps: {
        marginBlockStart: '700',
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.assignAssignee"
        })
      },
      render: input => /*#__PURE__*/_jsx(HubSpotterAccountUsersSelect, Object.assign({}, input, {
        accountId: accountId,
        disabled: isEditing
      })),
      validators: [required]
    })]
  });
};
const PlaylistAssignImpl = ({
  playlistId
}) => {
  const {
    playlist
  } = usePlaylist(playlistId);
  const {
    portalId,
    assignmentIds
  } = usePlaylistAssignmentsParams();
  const isEditing = assignmentIds && !!assignmentIds.length;
  const {
    accounts
  } = useAccounts();
  const {
    playlistAssignments
  } = usePlaylistAssignments({
    playlistId,
    assignmentIds,
    portalId,
    skip: !isEditing
  });
  const {
    createPlaylistAssignment,
    createPlaylistAssignmentError
  } = useCreatePlaylistAssignment();
  const {
    updatePlaylistAssignments,
    updatePlaylistAssignmentsError
  } = useUpdatePlaylistAssignments();
  const navigate = useNavigate();
  const {
    setLatestInteraction
  } = useLatestSavedItemsInteractions();
  const closeDestination = portalId ? getAssignmentsForPortalUrl({
    portalId,
    playlistId
  }) : getPortalAssignmentsUrl({
    playlistId
  });
  const isMultiUserAccount = (accounts || []).length > 1;
  const handleSubmitAsync = useCallback(async formData => {
    const {
      dueDate,
      account,
      assignees
    } = formData;
    const dueDateUnixTs = dueDate ? fromUiDateInputFormatToUnixTs(dueDate) : undefined;
    if (!isEditing) {
      assignees.forEach(assignee => {
        UsageTracker.track('playlistInteraction', {
          action: 'playlist-assigned',
          playlistId,
          portalId,
          hubspotterId: assignee,
          bulk: assignees.length > 1,
          date: dueDateUnixTs
        });
      });
    }
    const response = isEditing ? await updatePlaylistAssignments({
      assignmentIds,
      dueDate: dueDateUnixTs
    }) : await createPlaylistAssignment({
      playlistId,
      portalId: account,
      assigneeUserIds: assignees,
      dueDate: dueDateUnixTs
    }).then(createdAssignments => {
      if (createdAssignments) {
        setLatestInteraction({
          playlistId,
          portalId: account,
          action: 'CREATE_PLAYLIST_ASSIGNMENT',
          assignmentIds: createdAssignments.map(assignment => assignment.id)
        });
      }
      return createdAssignments;
    });

    /**
     * If we receive a response, it means the request was successful.
     */
    if (response) {
      navigate(closeDestination);
    }
  }, [assignmentIds, closeDestination, createPlaylistAssignment, isEditing, navigate, playlistId, portalId, setLatestInteraction, updatePlaylistAssignments]);
  if (isEditing && playlistAssignments && !playlistAssignments.length) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: closeDestination
    });
  }
  let dueDate = null;
  if (playlistAssignments && playlistAssignments.length) {
    // gets due date from assignments (if all have the same)
    dueDate = playlistAssignments[0].dueDate;
    if (playlistAssignments.some(pa => pa.dueDate !== dueDate)) dueDate = null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        justify: "between",
        children: [playlist && /*#__PURE__*/_jsx(H2, {
          marginBlockEnd: "0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.assignPlaylistName",
            options: {
              playlistName: playlist.name
            }
          })
        }), /*#__PURE__*/_jsx(RouterButton, {
          "aria-label": I18n.text('learningCenter.common.close'),
          responsive: false,
          to: closeDestination,
          use: "unstyled",
          children: /*#__PURE__*/_jsx(RemoveIcon, {
            color: "icon-core-on-fill-default",
            size: "300"
          })
        })]
      })
    }), playlist && accounts && /*#__PURE__*/_jsx(Form, {
      initialValues: isEditing && playlistAssignments ? {
        assignees: playlistAssignments.map(pa => pa.assignee.userId),
        dueDate: dueDate ? fromDateToUiDateInputFormat(new Date(dueDate)) : null,
        accountsRadio: 'myAccounts',
        account: portalId
      } : {
        dueDate: null,
        account: portalId || accounts.length && accounts[0].id || null,
        accountsRadio: 'myAccounts'
      },
      onSubmit: handleSubmitAsync,
      render: ({
        handleSubmit,
        values: {
          account: accountId,
          accountsRadio
        }
      }) => /*#__PURE__*/_jsx(NavMarker, {
        name: "ASSIGN_PLAYLIST_LOADED",
        children: /*#__PURE__*/_jsxs(FoundationsForm, {
          onSubmit: e => void handleSubmit(e),
          children: [/*#__PURE__*/_jsxs(DialogBody, {
            paddingBlockStart: "500",
            paddingInlineEnd: "900",
            paddingInlineStart: "800",
            children: [/*#__PURE__*/_jsx(ServerError, {
              error: createPlaylistAssignmentError || updatePlaylistAssignmentsError
            }), /*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: accountsRadio === 'allAccounts' ? 'learningCenter.playlists.assignIntroductionPortalSearch' : isMultiUserAccount ? 'learningCenter.playlists.assignIntroductionMultiAccount' : 'learningCenter.playlists.assignIntroductionSingleAccount'
              })
            }), /*#__PURE__*/_jsx(HasScope, {
              fallback: /*#__PURE__*/_jsx(StandardPortalUserAssign, {
                accountId: accountId,
                accounts: accounts,
                isEditing: isEditing,
                isMultiUserAccount: isMultiUserAccount
              }),
              override: isEditing,
              scope: "academy-playlist-global-assignment",
              children: /*#__PURE__*/_jsx(AccountsTabs, {
                allAccounts: /*#__PURE__*/_jsx(HubSpotterPortalUserAssign, {
                  accountId: accountId,
                  accounts: accounts,
                  isEditing: isEditing,
                  isMultiUserAccount: isMultiUserAccount
                }),
                myAccounts: /*#__PURE__*/_jsx(StandardPortalUserAssign, {
                  accountId: accountId,
                  accounts: accounts,
                  isEditing: isEditing,
                  isMultiUserAccount: isMultiUserAccount
                })
              })
            }), /*#__PURE__*/_jsx(FinalFormField, {
              fieldProps: {
                name: 'dueDate',
                allowNull: true
              },
              formControlProps: {
                marginBlockStart: '700',
                label: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.common.dueDate"
                })
              },
              render: input => /*#__PURE__*/_jsx(DateInput, Object.assign({}, input, {
                min: fromDateToUiDateInputFormat(new Date()),
                tz: "utc"
              }))
            }), /*#__PURE__*/_jsx(Text, {
              as: "small",
              use: "help",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.playlists.assignDueDateHelpText"
              })
            })]
          }), /*#__PURE__*/_jsxs(DialogFooter, {
            children: [/*#__PURE__*/_jsx(Button, {
              type: "submit",
              use: "primary",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.common.assign"
              })
            }), /*#__PURE__*/_jsx(UIRouterButton, {
              to: closeDestination,
              use: "secondary",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.common.cancel"
              })
            })]
          })]
        })
      })
    })]
  });
};
export const PlaylistAssignPanel = ({
  playlistId
}) => {
  return /*#__PURE__*/_jsx(ModalPanel, {
    width: 512,
    children: /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(PlaylistAssignImpl, {
        playlistId: playlistId
      })
    })
  });
};